module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseDropdown__container', _vm.className]
  }, [(_vm.icon) ? _c('i', {
    class: ['BaseDropdown__icon', _vm.icon]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "BaseDropdown",
    class: {
      'BaseDropdown_error': (_vm.errors && _vm.errors.length > 0)
    }
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    staticClass: "BaseDropdown__select",
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        _vm.change($event)
      }
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('option', {
      key: item.id,
      staticClass: "BaseDropdown__option",
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n                " + _vm._s(_vm.translate(item.name)) + "\n            ")])
  })), _vm._v(" "), _c('BaseErrors', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "BaseDropdown__label"
  }, [_vm._v("\n            " + _vm._s(_vm.translate(_vm.label)) + "\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bf54ba5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseDropdown.vue
// module id = 505
// module chunks = 1